var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M82.67 421.33C74.67 421.33 69.33 416 69.33 408C69.33 369.2 69.33 58.8 69.33 20C69.33 12 74.67 6.67 82.67 6.67C130.27 6.67 511.07 6.67 558.67 6.67C566.67 6.67 572 12 572 20C572 58.8 572 369.2 572 408C570.67 416 565.33 421.33 557.33 421.33C462.4 421.33 130.13 421.33 82.67 421.33ZM545.33 394.67L545.33 33.33L96 33.33L96 394.67L545.33 394.67Z",
    id: "a64zcdrxZy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 633.33C14.67 633.33 10.67 630.67 8 626.67C5.33 622.67 5.33 617.33 8 613.33C14.27 601.6 64.4 507.73 70.67 496C73.33 492 77.33 489.33 82.67 489.33C130.27 489.33 511.07 489.33 558.67 489.33C564 489.33 568 492 570.67 496C576.93 507.73 627.07 601.6 633.33 613.33C636 617.33 636 622.67 633.33 626.67C629.33 630.67 625.33 633.33 620 633.33C500 633.33 80 633.33 20 633.33ZM598.67 606.67L550.67 516L90.67 516L42.67 606.67L598.67 606.67Z",
    id: "a4krWNM5QJ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.67 338.67C146.67 338.67 141.33 333.33 141.33 325.33C141.33 303.07 141.33 124.93 141.33 102.67C141.33 94.67 146.67 89.33 154.67 89.33C187.73 89.33 452.27 89.33 485.33 89.33C493.33 89.33 498.67 94.67 498.67 102.67C498.67 124.93 498.67 303.07 498.67 325.33C498.67 333.33 492 338.67 485.33 338.67C419.2 338.67 187.73 338.67 154.67 338.67ZM472 312L472 116L168 116L168 312L472 312Z",
    id: "a8DvPgVZNe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 250.67C295.47 236.93 163.2 127.07 146.67 113.33C142.67 109.33 141.33 104 142.67 98.67C144 93.33 149.33 89.33 154.67 89.33C187.73 89.33 452.27 89.33 485.33 89.33C490.67 89.33 496 93.33 497.33 98.67C498.67 104 497.33 109.33 493.33 113.33C476.8 127.07 344.53 236.93 328 250.67C326.67 253.33 322.67 253.33 320 253.33C317.33 253.33 313.33 252 312 250.67ZM320 222.67L448 116L192 116L320 222.67Z",
    id: "ci7T71c3v"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a64zcdrxZy",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a64zcdrxZy",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4krWNM5QJ",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4krWNM5QJ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a8DvPgVZNe",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a8DvPgVZNe",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ci7T71c3v",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ci7T71c3v",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.263b66a16afe299908f360764cd2946e.svg";
export { ForwardRef as ReactComponent };